import { useHookForm, BaseFormDialog } from '@cks-internal/react-base';
import { Text, UseDisclosureReturn } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { hoursType } from '../../../features/workflow/types';
import { useWorkflowSocket } from '../../../features/workflow/hub/useWorkflowSocket';
import { formatToTime } from '../../../features/workflow/utils/formatter';
import { timeOptionsSelect } from '../../../features/workflow/utils/timeOptionsSelect';
import { PropsWithChildren } from 'react';

const mapDateString = (str: string | undefined | null) => dayjs(str).format('DD-MMM-YYYY h:mm A');
type ScheduleFrom = { ShiftEnd?: string; Lunch?: hoursType; IsCoordinator?: boolean };
export const SetScheduleForm = (
  props: {
    IsCoordinator?: boolean;
    shift: hoursType | undefined;
    lunch: hoursType | undefined;
    id: string | undefined;
    disclosure: UseDisclosureReturn;
    isDialog?: boolean;
    userName?: string;
  } & PropsWithChildren
) => {
  const invoke = useWorkflowSocket((r) => r.invoke);
  const { formMethods, fieldHelper } = useHookForm<ScheduleFrom>(
    {
      ShiftEnd: mapDateString(props.shift?.End),

      Lunch: {
        End: mapDateString(props.lunch?.End),
        Start: mapDateString(props.lunch?.Start)
      },
      IsCoordinator: props.IsCoordinator
    },
    [props]
  );
  const fields = [
    fieldHelper.switchInput('IsCoordinator').withLabel('Set To Manager'),
    fieldHelper
      .selectInput('ShiftEnd', { items: timeOptionsSelect() })
      .withLabel('Shift End')
      .withInputProps({ disableSort: true })
      .withValidation({ required: {} })
      .withRenderUnder(
        <Text fontStyle={'italic'} fontSize={'xs'}>
          Started at {formatToTime(props.shift?.Start)}
        </Text>
      ),
    fieldHelper
      .selectInput('Lunch.Start', { items: timeOptionsSelect() })
      .withLabel('Break Start')
      .withInputProps({ disableSort: true }),
    fieldHelper
      .selectInput('Lunch.End', { items: timeOptionsSelect() })
      .withLabel('Break End')
      .withInputProps({ disableSort: true })
  ];
  return (
    <BaseFormDialog
      header={`Set ${props.userName ?? 'My'} Schedule`}
      isLoading={false}
      onSubmit={async (d) => {
        await invoke('ScheduleUpdate', d.ShiftEnd, d.Lunch?.Start, d.Lunch?.End, d.IsCoordinator, props.id);
        props.disclosure?.onClose();
      }}
      formMethods={formMethods}
      fields={fields}
      disclosure={props.disclosure}
      dragDialog={{}}
    />
  );
};
